<template>
  <div class="d-flex justify-content-center" id="modal-unsubscribeconfirm">
    <div class="modal-dialog modal-md">
      <form name="form.unsubscribe" action  @submit.prevent="processUnsubscribe">
        <div class="modal-content">
          <div class="m-portlet__head modal-unsubscribe-title">
            <h3 class="m-portlet__head-text">{{$t("message.ei_personal_employee_unlink")}}</h3>
          </div>
          <hr class="w-100 mt-0 mb-0"/>
          <div class="unsubscribe-container">
            <div class="mb-4">
              <p class="modal-unsubscribe-subtitle">
                {{$t("message.unsubscribe.date")}}
              </p>
              <datepicker
                  data-vs-datepicker="date-departure-input"
                  @cleared = "unsubscribe.fecha_baja = ''"
                  :language="es"
                  name="fecha_baja"
                  id="fecha_baja"
                  format="dd/MM/yyyy"
                  :bootstrap-styling="true"
                  clear-button-icon="fa fa-times"
                  :clear-button="true"
                  v-model="unsubscribe.fecha_baja"
                  input-class="input-datepicker"
                  @closed="onTouchDate">
              </datepicker>
              <label class="is-invalid-date" v-show="isInvalidDate">{{ $t('message.unsubscribe.date_invalid') }}</label>
            </div>
            <div class="mb-4">
              <p class="modal-unsubscribe-subtitle">{{$t("message.unsubscribe.confirm_unsubscribe_why")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
              <select data-vs-select="eform-template-select" class="form-control m-input eform_templates" v-model="unsubscribe.selected" >
                <option v-for="(item, index) in unsubscribe.options" :data-vs-option-value="`temp-${index}`" :key="item.name" :value="item.name">{{item.name}}</option>
              </select>
            </div>
            <div class="mb-4">
              <p class="modal-unsubscribe-subtitle">{{$t("message.unsubscribe.confirm_unsubscribe_observation")}}</p>
              <textarea data-vs-textarea="observation-field" maxlength="250" v-model="unsubscribe.observations" class="form-control"></textarea>
            </div>
          </div>

          <div class="buttons-container d-flex justify-content-center">
            <button data-vs-button="cancel-unsubscribe" type="button" @click="clearFields" :disabled="loadingReactivate" data-dismiss="modal" class="btn btn-secondary m-3 w-100">{{$t("message.unsubscribe.action_cancel")}}</button>
            <button
              data-vs-button="submit-unsubscribe"
              v-if="!loadingReactivate"
              type="submit"
              class="btn btn-primary m-3 w-100">
              {{$t("message.unsubscribe.action_unsubscribe")}}
            </button>
            <button data-vs-button="submit-unsubscribe" v-if="loadingReactivate" :disabled="true" class="btn btn-primary m-3 w-100">
              <div class="m-loader m-loader--light"></div>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
    import User from '../../../apiClient/User';
    import UserManagement from '../../../apiClient/UserManagement';
    import datepicker from "vuejs-datepicker";
    import {es} from "vuejs-datepicker/dist/locale";
    import moment from "moment";

    export default {
        components: {
            datepicker,
        },
        data (){
            return {
                loadingReactivate: false,
                isTouchedDate: false,
                es: es,
                userClient: User,
                userNew: UserManagement,
                unsubscribe:{
                    fecha_baja: "",
                    options:[
                        {id:1,name:"Desvinculación"},
                        {id:2,name:"Fin de contrato"},
                        {id:3,name:"Renuncia"},
                        {id:4,name:"Jubilación"},
                        {id:5,name:"Baja de candidato"},
                        {id:6,name:"Otros"}
                    ],
                    selected:'Desvinculación',
                    observations:""
                },
            }
        },
        created(){
            this.userClient = new User();
            this.userNew = new UserManagement();
        },


        methods: {
            clearFields() {
                this.unsubscribe.fecha_baja = '';
                this.unsubscribe.observations = '';
                this.isTouchedDate = false;
            },
            onTouchDate() {
                this.isTouchedDate = true
            },
            processUnsubscribe (){

                if (this.unsubscribe.fecha_baja) {
                    this.loadingReactivate = true;
                    this.userClient.unsubscribe(this.$route.params.id,
                        this.unsubscribe.selected,
                        this.unsubscribe.observations,
                        moment(this.unsubscribe.fecha_baja).format('DD/MM/YYYY')).then((res) => {
                        if (res.status === 200) {
                            this.loadingReactivate = false;
                            $('#unsubscribeConfirmationModal').modal('hide');
                            swal({
                                type: "success",
                                title: `${this.$t("message.unsubscribe.confirm_unsubscribe_success")}`,
                                showConfirmButton: true,
                                confirmButtonText: `${this.$t(
                                    "message.billboard_form_post_button_confirm"
                                )}`
                            }).then(() => {
                                this.clearFields();
                                this.$emit('isUnsubscribed', true);
                            });
                        }
                    })
                    .catch((error) => {
                        this.loadingReactivate = false;
                        $('#unsubscribeConfirmationModal').modal('hide');
                        this.clearFields();
                        let txtMsg = `${this.$t("message.unsubscribe.error_default")}`;
                        if (error.response.hasOwnProperty("data")){
                            txtMsg = `${this.$t("message.unsubscribe.error_"+error.response.data.code)}`;
                        }
                        swal({
                            type: "error",
                            title: txtMsg,
                            showConfirmButton: true,
                            confirmButtonText: "Aceptar"
                        });
                        console.log(error.response);
                    });
                }
                else {
                    this.isTouchedDate = true
                }
            },
        },
        computed: {
            isInvalidDate() {
                return this.isTouchedDate && this.unsubscribe.fecha_baja.length === 0
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./public/assets/scss/components/unsubscribeconfirm.scss";
</style>